import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { API_URL } from "../../../../constants";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import {
  DeleteServiceCaller,
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import Select from "react-select";

const GeneralMasterEdit = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  useEffect(() => {
    dispatch(updateNavbarHeading("General Master Edit"));
  }, []);
  const initialFormData = {
    ID:"",
    Code: "",
    Name: "",
    Description: "",
    IsSystem: 0,
    gmDetailLines: [
      {
        Name: "",
        Code: "",
        Description: "",
        IsInactive: 0,
      },
    ],
    gmSubDetailLines: [
      {
        // GeneralMasterDetailID: "",
        SubDetailName: "",
        SubDetailDescription: "",
        IsInactive: 0,
      },
    ],
  };
  const [formData, setFormData] = useState(initialFormData);
  console.log("formData", formData);
  const [masterList, setMasterList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    if (id) {
      fetchGeneralMaster(id);
    }
  }, []);

  const fetchGeneralMaster = async (id) => {
    const response = await GetServiceCaller(`${API_URL}general-master/${id}`);
    if (response.status === 200) {
      const fetchData = response?.data?.data?.generalMaster;
      const fetchLineData = response?.data?.data?.generalMasterDetails;

      const listOfMaster = response?.data?.data?.gmDeatilList;
      const mastersOpt = listOfMaster?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setMasterList(mastersOpt);

      // Map through fetchLineData to create the Lines array
      const Lines = fetchLineData.map((item) => ({
        ID: item?.ID,
        Name: item?.Name,
        Code: item?.Code,
        Description: item?.Description,
        IsInactive: item?.IsInactive,
      }));

      // Create form data object
      const formDataEdit = {
        ID: fetchData?.ID,
        Code: fetchData?.Code,
        Name: fetchData?.Name,
        Description: fetchData?.Description,
        IsSystem: fetchData?.IsSystem,
        gmDetailLines: Lines,
      };

      // Set form data
      setFormData(formDataEdit);
      setPageLoading(false);
    } else {
      console.error(
        "Failed to fetch model masters. Server responded with status:",
        response.status
      );
    }
  };

  const handleAddBrandLine = () => {
    let newLineNo = 1; // Start from 1
    const existingLineNos = formData.gmDetailLines.map((row) => row.ID);
    while (existingLineNos.includes(newLineNo)) {
      newLineNo++; // Find the next available ID
    }

    setFormData((prevState) => ({
      ...prevState,
      gmDetailLines: [
        ...prevState.gmDetailLines,
        {
          Name: "",
          Code: "",
          Description: "",
          IsInactive: 0,
        },
      ],
    }));
  };
  const handleAddSubMasterLine = () => {
    let newLineNo = 1; // Start from 1

    // Ensure gmSubDetailLines exists and is an array
    const existingLineNos =
      formData?.gmSubDetailLines?.map((row) => row.ID) || [];

    while (existingLineNos.includes(newLineNo)) {
      newLineNo++; // Find the next available ID
    }

    setFormData((prevState) => ({
      ...prevState,
      gmSubDetailLines: [
        ...(prevState?.gmSubDetailLines || []),
        {
          ID: newLineNo, // Assign a unique ID
          GeneralMasterDetailID: "",
          SubDetailName: "",
          SubDetailDescription: "",
          IsInactive: 0,
        },
      ],
    }));
  };

  const handleChange = async (e) => {
    const { name, checked, type } = e.target;
    const value = type === "checkbox" ? (checked ? 1 : 0) : e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleMaster = (e, index) => {
    const { name, checked, type } = e.target;
    const value = type === "checkbox" ? (checked ? 0 : 1) : e.target.value;

    const updatedLines = [...formData?.gmDetailLines];
    updatedLines[index] = {
      ...updatedLines[index],
      [name]: value,
    };

    const updatedFormData = { ...formData, gmDetailLines: updatedLines };
    setFormData(updatedFormData);
  };
  const handleSubMaster = (e, index) => {
    const { name, checked, type } = e.target;
    const value = type === "checkbox" ? (checked ? 1 : 0) : e.target.value;

    const updatedLines = [...formData?.gmSubDetailLines];
    updatedLines[index] = {
      ...updatedLines[index],
      [name]: value,
    };

    const updatedFormData = { ...formData, gmSubDetailLines: updatedLines };
    setFormData(updatedFormData);
  };
  const handleSubmit = async (e) => {
      e.preventDefault();
  
      console.log("formData Inside the submit", formData);
      setLoading(true);
  
      try {
        const response = await PostServiceCaller(
          `${API_URL}general-master/${formData.ID}`,
          formData,
          "put"
        );
  
        if (response.status === 200) {
          toast.success("Data submitted successfully");
          setTimeout(() => {
              window.location.href = "/rujul/admin/general-master";
          }, 2000);
        } else {
          console.error(
            "Failed to submit data. Server responded with status:",
            response.status
          );
          console.error("Response data:", response.data);
        }
      } catch (error) {
        console.error("Unexpected Error:", error);
      } finally {
        setLoading(false);
      }
    };

    if (pageLoading) {
      return (
        <>
          <p class="position-absolute top-50 start-50 translate-middle text-center">
            <FaSpinner class="spinner" />
          </p>
        </>
      );
    } else {
        return (
            <div className="Container" id="form-input-section">
              <form
                onSubmit={handleSubmit}
                id="formOne"
                className="rounded bg-white"
              >
                <div className="row">
                <div className="col-md-4 flex-col">
                  <div class="card">
                    <div class="card-header">
                      <h5 className="subheading">General Details</h5>
                    </div>
                    <div className="card-body">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label className="form-label">Code</label>
                            <input
                              type="text"
                              name="Code"
                              placeholder="Code"
                              className="form-control"
                              value={formData?.Code}
                              disabled
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label className="form-label">Name</label>
                            <input
                              type="text"
                              name="Name"
                              placeholder="Name"
                              className="form-control"
                              value={formData?.Name}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label className="form-label">Description</label>
                            <textarea
                              type="text"
                              name="Description"
                              placeholder="Description"
                              className="form-control"
                              value={formData?.Description}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                        <div className="col-md-5 pt-5">
                          <label className="form-label">As System</label>
                          <input
                            className="form-check-input ms-2 "
                            type="checkbox"
                            name="IsSystem"
                            id="flexSwitchCheckChecked"
                            checked={formData.IsSystem === 1}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-8">
                <div className="row">
                  <ul className="nav nav-tabs overflow" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        style={{ color: "#2F2E4B" }}
                        id="assetCategory-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#assetCategory"
                        type="button"
                        role="tab"
                        aria-controls="assetCategory"
                        aria-selected="true"
                      >
                        Master Details
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        style={{ color: "#2F2E4B" }}
                        id="brandDetails-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#brandDetails"
                        type="button"
                        role="tab"
                        aria-controls="brandDetails"
                        aria-selected="false"
                      >
                        Sub Master Details
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    {/** Main Form Code start */}
                    <div
                      className="tab-pane fade show active"
                      id="assetCategory"
                      role="tabpanel"
                      aria-labelledby="assetCategory-tab"
                    >
                      <div className="table-responsive brand-details rounded mt-2">
                        <button
                          type="button"
                          onClick={handleAddBrandLine}
                          className="custom-btn mb-2 pull-right btn btn-sm text-white"
                        >
                          <i class="fa fa-plus"></i>&nbsp;Add
                        </button>
                        <Table
                          style={{ background: "#ECECEC !important" }}
                          // id="poctable_head"
                          className="table table-bordered"
                        >
                          <thead id="thcolor" className="text-center align-middle  ">
                            <tr>
                              <th className="col-2">Code</th>
                              <th>Name</th>
                              <th>Description</th>
                              <th>IsInActive</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {formData?.gmDetailLines?.map((ele, index) => (
                              <tr key={ele.ID}>
                                <td>
                                  <input
                                    type="text"
                                    name="Code"
                                    className="form-control"
                                    value={ele?.Code || ""}
                                    onChange={(e) => handleMaster(e, index)}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    name="Name"
                                    className="form-control"
                                    value={ele?.Name || ""}
                                    onChange={(e) => handleMaster(e, index)}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    name="Description"
                                    className="form-control"
                                    value={ele?.Description || ""}
                                    onChange={(e) => handleMaster(e, index)}
                                  />
                                </td>
                                <td className="text-center align-middle">
                                  <input
                                    type="checkbox"
                                    name="IsInactive"
                                    checked={ele.IsInactive}
                                    className="form-check-input"
                                    onChange={(e) => handleMaster(e, index)}
                                  />
                                </td>
                                <td className="text-center align-middle">
                                  <i
                                    className="fa fa-trash"
                                    style={{ fontSize: "1.2rem", cursor: "pointer" }}
                                    onClick={() => {
                                      setFormData((prevState) => ({
                                        ...prevState,
                                        gmDetailLines: prevState.gmDetailLines.filter(
                                          (_, i) => i !== index
                                        ),
                                      }));
                                    }}
                                  ></i>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade show p-2"
                      id="brandDetails"
                      role="tabpanel"
                      aria-labelledby="brandDetails-tab"
                    >
                      <div className="table-responsive brand-details rounded mt-2">
                        <button
                          type="button"
                          onClick={handleAddSubMasterLine}
                          className="custom-btn mb-2 pull-right btn btn-sm text-white"
                        >
                          <i class="fa fa-plus"></i>&nbsp;Add
                        </button>
                        <Table
                          style={{ background: "#ECECEC !important" }}
                          // id="poctable_head"
                          className="table table-bordered"
                        >
                          <thead id="thcolor" className="text-center align-middle  ">
                            <tr>
                              <th>Master Name</th>
                              <th>Sub Master Name</th>
                              <th>Description</th>
                              <th>IsInActive</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {formData?.gmSubDetailLines?.map((ele, index) => (
                              <tr key={ele.ID || index}>
                                <td>
                                  <Select
                                    //   value={selectedProject}
                                    // value={projectList.find(
                                    //   (opt) => opt.value === formData.ProjectID
                                    // )}
                                    options={masterList}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    name="SubDetailName"
                                    className="form-control"
                                    value={ele?.SubDetailName || ""}
                                    onChange={(e) => handleSubMaster(e, index)}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    name="SubDetailDescription"
                                    className="form-control"
                                    value={ele?.SubDetailDescription || ""}
                                    onChange={(e) => handleSubMaster(e, index)}
                                  />
                                </td>
                                <td className="text-center align-middle">
                                  <input
                                    type="checkbox"
                                    name="IsInactive"
                                    checked={ele.IsInactive === 1}
                                    className="form-check-input"
                                    onChange={(e) => handleSubMaster(e, index)}
                                  />
                                </td>
                                <td className="text-center align-middle">
                                  <i
                                    className="fa fa-trash"
                                    style={{ fontSize: "1.2rem", cursor: "pointer" }}
                                    onClick={() => {
                                      setFormData((prevState) => ({
                                        ...prevState,
                                        gmSubDetailLines:
                                          prevState.gmSubDetailLines.filter(
                                            (_, i) => i !== index
                                          ),
                                      }));
                                    }}
                                  ></i>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
                </div>
               
                <div className="d-flex justify-content-end">
                  <div className="d-flex me-2">
                    <div>
                      <button
                        type="button"
                        className="cancel-btn me-2"
                        onClick={() => (window.location.href = "/rujul/admin/general-master")}
                      >
                        Cancel
                      </button>
                    </div>
                    <div>
                      <button type="submit" className="custom-btn">
                        {/* {loading ? <FaSpinner class="sm-spinner" /> : "Submit"} */}
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          );
    }
 
};

export default GeneralMasterEdit;
